/* istanbul ignore file */
import { ACCOUNT_PATH } from 'domain/shared/account';
import { TransferTimelineRecordToAnotherEntityButton } from 'domain/shared/timeline/button';
import TransferActivityFormSection from 'domain/sales/shared/timeline/activity/form/TransferActivityFormSection';
import { useMessageService, SuccessMessage } from 'framework/ui/Message';
import { ENTITY_TYPE_ALIAS } from 'domain/sales/shared/timeline/activity/shared/transferActivityService';
import { LEADS_PATH } from 'domain/shared/lead';
import { OPPORTUNITY_PATH } from 'domain/shared/core/sharedRouteConstants';
import { CRM_ACTIVITY_URL_POSTFIX } from 'domain/sales/shared/timeline/activity/crmActivityConstants';
import { FormFieldsData } from 'framework/form';
import { ValidationSchema } from 'validation-schema-library';
import { Link } from 'react-router-dom';

type TransferCrmActivityToAnotherEntityButtonProps = {
  permissionToCheck: Nullable<string | string[]>;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
  timelineId: string;
  modalTitle: string;
  getValidationSchemaFunc?: () => Promise<ValidationSchema>;
  additionalAfterSubmit?: (response: any) => void;
  isApplicable: boolean;
};

const TransferCrmActivityToAnotherEntityButton = ({
  isApplicable,
  ...props
}: TransferCrmActivityToAnotherEntityButtonProps) => {
  const { addMessage } = useMessageService();

  if (!isApplicable) return null;

  const getPath = (entityType: string, entityId: string, entryId: string) => {
    let basePath = '';
    if (entityType === ENTITY_TYPE_ALIAS.LEAD) {
      basePath = LEADS_PATH;
    } else if (entityType === ENTITY_TYPE_ALIAS.ACCOUNT) {
      basePath = ACCOUNT_PATH;
    } else if (entityType === ENTITY_TYPE_ALIAS.OPPORTUNITY) {
      basePath = OPPORTUNITY_PATH;
    }
    return `${basePath}/${entityId}/${CRM_ACTIVITY_URL_POSTFIX}/${entryId}`;
  };

  return (
    <TransferTimelineRecordToAnotherEntityButton
      additionalAfterSubmit={response => {
        const path = getPath(response.entityType, response.entityId, response.timelineId);
        addMessage(
          new SuccessMessage(
            <>
              You awe awesome! CRM activity has been successfully transfer to another entity.
              <Link to={path} style={{ marginLeft: 1 }}>
                Please, check new location.
              </Link>
            </>,
          ),
        );
      }}
      {...props}
    >
      <TransferActivityFormSection />
    </TransferTimelineRecordToAnotherEntityButton>
  );
};

export default TransferCrmActivityToAnotherEntityButton;
